import { AbstractCommand } from 'src/models/command';

interface TaskDelayItem {
	aggregateId: string;
	targetDate: string;
}

class BatchDelayTasksToSpecificDateCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_BatchDelayTasksToSpecificDate';

	public constructor(taskDelays: TaskDelayItem[]) {
		super();

		if (!Array.isArray(taskDelays)) {
			throw new Error('taskDelays must be an array');
		}

		if (taskDelays.length === 0) {
			throw new Error('taskDelays array cannot be empty');
		}

		if (
			!taskDelays.every(
				(item) =>
					typeof item.aggregateId === 'string' &&
					item.aggregateId.trim().length > 0 &&
					typeof item.targetDate === 'string' &&
					item.targetDate.trim().length > 0
			)
		) {
			throw new Error('All task delay items must have valid aggregateId and targetDate (non-empty strings)');
		}

		this.parameters = {
			batchSize: taskDelays.length,
			taskDelays: taskDelays as unknown as Array<Record<string, string>>,
		};
	}
}

export { BatchDelayTasksToSpecificDateCommand };
export type { TaskDelayItem };
